export enum PermissionFavoritesOption {
  FAVORITES_COMMON_LOGIN = 'direcciones-favoritas',
  FAVORITES_MANAGE_LIST = '/direcciones-favoritas/lista-de-direcciones',
  FAVORITES_MANAGE_ADD = '/direcciones-favoritas/crear',
  FAVORITES_MANAGE_SAVE = '/direcciones-favoritas/editar',
  FAVORITES_MANAGE_CREATE = 'favorite.manage.create',
  FAVORITES_MANAGE_EDIT = 'favorite.manage.edit',
  FAVORITES_MANAGE_DELETE = 'favorite.manage.delete',
}
